export const throwErrorAsync = error => {
  setTimeout(() => {
    throw error;
  }, 0);
};